
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class FormGroupError extends Vue {
    @Prop({ type: String, required: true }) readonly error!: string;
  }
